import styled from "styled-components/macro";
import colors from "./variables/colors";

export const SimpleRound = styled.span`
  font-size: 20px;
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  background-color: ${colors.white.base};
  text-align: center;
  line-height: 2em;
  border-radius: 50%;
  color: ${colors.slate.base};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default SimpleRound;
